module.exports = __webpack_public_path__ + "img/step3.14d94515.png";